import script from "./VenueInfoWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./VenueInfoWidget.vue?vue&type=script&setup=true&lang=js"

import "./VenueInfoWidget.vue?vue&type=style&index=0&id=3f41d19f&lang=scss"

const __exports__ = script;

export default __exports__